import { Button, CircularProgress, Tab, Tabs, TextField } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/Table';
import * as summaryActions from '../../../store/actions/stats';
import * as types from '../../../store/types/stats';

import { Search as SearchIcon } from '@material-ui/icons';

interface IState {
  tabId: number;
  customRange: {
    from: Date | null;
    to: Date | null;
  };
}

class GeneralSummary extends React.Component<any, IState> {
  private static readonly STEP = {
    DAY: 0,
    WEEK: 1,
    MONTH: 2,
    CUSTOM: 3,
  };

  public state = {
    tabId: 0,
    customRange: {
      from: null,
      to: null,
    },
  };
  public componentDidMount() {
    this.props.fetchGeneralStats();
  }

  public onSwitch(tabId: number) {
    return () => {
      this.setState({ tabId: tabId });
      switch (tabId) {
        case GeneralSummary.STEP.DAY:
          this.props.fetchGeneralStats('day');
          break;
        case GeneralSummary.STEP.WEEK:
          this.props.fetchGeneralStats('week');
          break;
        case GeneralSummary.STEP.MONTH:
          this.props.fetchGeneralStats('month');
          break;
      }
    };
  }

  public handleCustomStepsChange(type: 'from' | 'to') {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({
        customRange: {
          ...this.state.customRange,
          [type]: event.target.valueAsDate,
        },
      });
    };
  }

  public handleCustomStepsSubmit() {
    return (event: React.FormEvent<Element>) => {
      event.preventDefault();
      const { from, to } = this.state.customRange;
      this.props.fetchGeneralStats(undefined, from, to);
    };
  }

  public render() {
    const rows = this.props.rows as types.IGeneralStatsRow[];

    const tabs = (
      <Tabs value={this.state.tabId}>
        <Tab label="Days" onClick={this.onSwitch(GeneralSummary.STEP.DAY)} />
        <Tab label="Weeks" onClick={this.onSwitch(GeneralSummary.STEP.WEEK)} />
        <Tab label="Months" onClick={this.onSwitch(GeneralSummary.STEP.MONTH)} />
        <Tab label="Custom" onClick={this.onSwitch(GeneralSummary.STEP.CUSTOM)} />
      </Tabs>
    );

    if (this.props.loading) {
      return (
        <>
          {tabs}
          <CircularProgress />
        </>
      );
    }

    if (!rows.length) {
      return (
        <>
          {tabs}
          <p>No data!</p>
        </>
      );
    }

    return (
      <>
        {tabs}
        {this.state.tabId === GeneralSummary.STEP.CUSTOM ? (
          <form onSubmit={this.handleCustomStepsSubmit()} noValidate={true}>
            <TextField
              label="From"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.handleCustomStepsChange('from')}
            />
            <TextField
              label="To"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.handleCustomStepsChange('to')}
            />
            <Button type="submit" variant="contained">
              <SearchIcon />
            </Button>
          </form>
        ) : null}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date Scope</TableCell>
              <TableCell numeric={true}>Registrations</TableCell>
              <TableCell numeric={true}>Registrations (Z/B)</TableCell>
              <TableCell numeric={true}>iOS Registrations</TableCell>
              <TableCell numeric={true}>Android Registrations</TableCell>
              <TableCell numeric={true}>Web Registrations</TableCell>
              <TableCell numeric={true}>Jobs</TableCell>
              <TableCell numeric={true}>Unique Employers</TableCell>
              <TableCell numeric={true}>Positive Applicants Average</TableCell>
              <TableCell numeric={true}>Applicants Average</TableCell>
              <TableCell numeric={true}>Successful Jobs</TableCell>
              <TableCell numeric={true}>Reviews</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(n => {
              return (
                <TableRow key={n.date_scope} hover={true}>
                  <TableCell>{n.date_scope}</TableCell>
                  <TableCell numeric={true}>{n.reg_count}</TableCell>
                  <TableCell numeric={true}>
                    {n.employer_reg_count}/{n.candidate_reg_count}
                  </TableCell>
                  <TableCell numeric={true}>{n.ios_reg_count}</TableCell>
                  <TableCell numeric={true}>{n.android_reg_count}</TableCell>
                  <TableCell numeric={true}>{n.web_reg_count}</TableCell>
                  <TableCell numeric={true}>{n.job_count}</TableCell>
                  <TableCell numeric={true}>{n.job_author_count}</TableCell>
                  <TableCell numeric={true}>{n.applied_job_average}</TableCell>
                  <TableCell numeric={true}>{n.reacted_job_average}</TableCell>
                  <TableCell numeric={true}>{n.successful_jobs}</TableCell>
                  <TableCell numeric={true}>{n.review_count}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </>
    );
  }
}

const mapStateToProps = (state: { stats: types.IStatsState }) => {
  return {
    rows: state.stats.general || [],
    loading: state.stats.loading,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchGeneralStats: (stepBy?: 'day' | 'week' | 'month', from?: Date, to?: Date) =>
      dispatch(summaryActions.fetchGeneralStatsRequest(stepBy, from, to)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralSummary);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/General/General.tsx